export enum MeasureRevision {
  R2015 = 1,
  R2025Pilot = 2,
  R2025SoftImplementation = 3,
  R2025 = 4
}
